import "core-js/features/array/find.js";
import "core-js/features/array/includes.js";
import "core-js/features/number/is-nan.js";
import "core-js/features/object/entries.js";
import "core-js/features/object/is.js";
import "core-js/features/object/values.js";
import "core-js/features/string/includes.js";
import "core-js/features/string/starts-with.js";
import "core-js/features/weak-map/index.js";
import "react-app-polyfill/ie9.js"; // This has to be the first line

import "./index.scss"; // import base styles before any component

import { closeMenu, errorMiddleware, injectScriptSrc, injectScriptText, newAppContext, normalizeLocale, onActionMiddleware, setCurrentDateTime, setLocale } from "@awe-web/shared/lib";
import { configureStore } from "@reduxjs/toolkit";
import { createRoot } from 'react-dom/client';
import smoothscroll from "smoothscroll-polyfill";
import WebFont from "webfontloader";
import App from "./app/components/app.js";
import { ErrorBoundary } from "./app/components/error_boundary.js";
import reducer from "./reducer.js";
import * as serviceWorker from "./serviceWorker.js";
import { setCurrentScrollPosition, setCurrentViewportWidth } from "./window/actions.js";

smoothscroll.polyfill();

// Load the following fonts
// "BMW Group Light" normal (n4)
// "BMW Group Condensed" normal (n4) and bold (n7)
// See https://github.com/typekit/fvd
WebFont.load({
  custom: {
    families: [
      "BMW Group Light:n4",
      "BMW Group Condensed:n4,n7"
    ]
  }
});

const updateConsentControllerLocale = onActionMiddleware("L10N/LOCALE_SET", (action) => {
  setLocale(action.payload.locale);
});

const config = window.config;
const context = newAppContext(config);

const localeMiddleWare = updateConsentControllerLocale;

const store = configureStore({
  // Pass previously created persisted reducer
  reducer: reducer,
  middleware: getDefaultMiddleware => {
    const middleware = getDefaultMiddleware({
      // Pass in a custom `extra` argument to the thunk middleware
      thunk: {
        extraArgument: context
      },
    }).concat(localeMiddleWare);

    return [errorMiddleware, ...middleware];
  }
});

store.dispatch(setCurrentDateTime());
setInterval(() => {
  store.dispatch(setCurrentDateTime());
}, 30000);
window.addEventListener("scroll", () => {
  store.dispatch(setCurrentScrollPosition());
});
window.addEventListener("resize", ((initialWidth) => {
  let lastWidth = initialWidth;

  return () => {
    store.dispatch(setCurrentViewportWidth());

    // Close the sidebar menu whenever the viewport gets wider and
    // potentially matches the next breakpoint.
    const newWidth = window.innerWidth;
    if (newWidth > lastWidth) {
      store.dispatch(closeMenu());
    }
    lastWidth = newWidth;
  };
})(window.innerWidth));

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <ErrorBoundary>
    <App store={store} />
  </ErrorBoundary>
);

(async function () {
  // initialize ePaaS Consent Controller
  if (config.consentController?.scriptSrc !== "...") {
    await injectScriptSrc(config.consentController.scriptSrc);
    window.epaas.api.initialize({
      tenant: config.consentController.tenant,
      locale: normalizeLocale(config.initialLocale),
      stage: config.consentController.stage
    });
  }

  // initialize Adobe Analytics
  if (config.analytics?.scriptSrc !== "...") {
    await injectScriptSrc(config.analytics.scriptSrc);
    injectScriptText("_satellite.pageBottom();");
  }

}());

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
